import { gridStoreResults } from 'fox-react/dist/components/FoxGrid/actions';
import gridNames from 'common/gridNames';
import ExportNavSrv from './ExportNavSrv';

export function storeResults(results) {
  return gridStoreResults(gridNames.exportNav)(results);
}

export function getForGrid(dataState) {
  return function(dispatch) {
    return ExportNavSrv.getForGrid(dataState).then(results => {
      dispatch(storeResults(results));
    });
  };
}
